import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles, MenuItem, TextField, Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CloseIcon from '@material-ui/icons/Close';
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showAlertSnackbar } from "../../reducers/uiSlice";
import { batchCorrectServiceWrongAddress, batchGeoWrongAddress, batchVerifyAddresses, getServiceWrongAddress } from "../../actions/wrongAddressActions";
import { getBranchById, getUserPreference } from "../../utilities/common";
import { DataGrid } from "@material-ui/data-grid";
import _ from "lodash";
import FullscreenLoading from "../Common/FullscreenLoading";
import { getBranchList } from "../../actions/commonAction";
import CorrectionModal from "./CorrectionModal";

const useStyles = makeStyles((theme)=> ({
    selectStyle: {
        cursor: 'pointer'
    },
}))

function BatchCorrectionModal(props) {
    const {t} = useTranslation('wrongAddressTool');
    const dispatch = useDispatch();
    const classes = useStyles();

    const userPref = getUserPreference();

    const columnsNeedCorrection = [
        {field: 'id', headerName: t('id'), hide: true},
        {
            field: 'tno', 
            headerName: t('tno'), 
            flex: 1,
            headerAlign: 'center', 
            sortable: false,
            align: 'center'
        },
        {
            field: 'address', 
            headerName: t('original_address'), 
            headerAlign: 'center',
            flex: 2,
            sortable: false,
            align: 'center'
        },
        {
            field: 'zipcode', 
            headerName: t('original_postal_code'), 
            flex: 1,
            headerAlign: 'center', 
            sortable: false,
            align: 'center'
        },
        {
            field: 'operation_count', 
            headerName: t('operation_count'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            align: 'center'
        },
        {
            field: 'delivery_type', 
            headerName: t('delivery_type'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            align: 'center',
            renderCell: (params) => {
                return (
                    <div style={params.row.delivery_type ? {color:'red'} : {color:'white'}}>
                        {params.row.delivery_type ? t('express') : t('regular')}
                    </div>
                )
            }
        }
    ];

    const columnsCorrectionResult = [
        {field: 'id', headerName: t('id'), hide: true},
        {
            field: 'tno', 
            headerName: t('tno'), 
            flex: 3,
            headerAlign: 'center', 
            sortable: false,
            align: 'center'
        },
        {
            field: 'original_address', 
            headerName: t('original_address'), 
            headerAlign: 'center',
            flex: 2,
            sortable: false,
            align: 'center',
            renderCell: (params) => {
                return (
                    <Tooltip title={params.row.original_address}>
                        <div 
                            style={params.row.exist ? {color:'red'} : {color:'orange'}}
                            className={classes.selectStyle}
                            onClick={(e)=>{
                                e.preventDefault();
                                handleBatchDetailOpen(params);
                            }}
                        >
                            {params.row.original_address}
                        </div>
                    </Tooltip>
                )
            }
        },
        {
            field: 'original_postal_code', 
            headerName: t('original_postal_code'), 
            flex: 1,
            headerAlign: 'center', 
            sortable: false,
            align: 'center'
        },
        {
            field: 'corrected_addr', 
            headerName: t('corrective_address'), 
            flex: 2, 
            headerAlign: 'center', 
            sortable: false,
            align: 'center',
            renderCell: (params) => {
                return (
                    <Tooltip title={params.row.corrected_addr}>
                        <div>
                            {params.row.corrected_addr}
                        </div>
                    </Tooltip>
                )
            }
        },
        {
            field: 'postal_code_long', 
            headerName: t('postal_code'), 
            flex: 1, 
            headerAlign: 'center', 
            sortable: false,
            align: 'center',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.new_postal_code ? params.row.new_postal_code : params.row.postal_code_long}
                    </div>
                )
            }
        },
        {
            field: 'lngLat',
            headerName: t('lat_lng'),
            sortable: false,
            flex: 2,
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.lat},{params.row.lng}
                    </div>
                )
            }
        }
    ];

    const deliveryTypeList = useSelector(state=>state.wrongAddressReducer.getDeliveryTypes);
    const branchList = useSelector(state => state.common.branches);
    const correctionList = useSelector(state=>state.wrongAddressReducer.getservicewrongaddress);

    const [deliveryType, setDeliveryType] = useState('ALL');
    const [loading, setLoading] = useState();
    const [fullscreenLoading, setFullscreenLoading] = useState(false);
    const [correctionStage, setCorrectionStage] = useState('before');
    const [correctionResultList, setCorrectionResultList] = useState([]);
    const [correctionVerifyList, setCorrectionVerifyList] = useState({});
    const [correctionModalOpen, setCorrectionModalOpen] = useState(false);
    const [correctionSelected, setCorrectionSelected] = useState([]);
    const [completeSelected, setCompleteSelected] = useState([]);
    const [CorrectDetail, setCorrectDetail] = useState({});
    const [addressList, setAddressList] = useState({});
    const [batchList, setBatchList] = useState('');
    const [isOneTime, setIsOneTime] = useState(0);


    const handleSearch = () => {
        setLoading(true);
        dispatch(getServiceWrongAddress({
            driver_id: getBranchById(userPref.userCity, branchList).wrong_address_collector,
            batch_list: batchList || null,
            warehouse: userPref.userCity,
            delivery_type: deliveryType
        }))
        .then(() => {
            setCorrectionStage('before');
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message:err.message,type:'error'}));
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const createRows = () => {
        if(correctionStage === 'before') {
            return _.map(addressList, (addressDetail, key) => {
                console.log(key)
                const { order_id, ...rest } = addressDetail;
                return {
                    id: order_id,
                    ...rest
                }
            })
        } else {
            return _.map(correctionResultList, (row) => {
                const { order_id, ...rest } = row
                return {
                    id: order_id,
                    exist: correctionVerifyList[row.order_id] || false,
                    tno: addressList[order_id].tno,
                    ...rest
                }
            })
        }
    }

    const handleCorrect = async() => {
        try {
            let paramsRaw = [];
            correctionSelected.forEach((id) => {
                paramsRaw.push(correctionList[id])
            });
            setFullscreenLoading(true);
            let params = paramsSingleMultiTransfer(paramsRaw, 'multi', 'correct');
            let responseCorrection = await dispatch(batchGeoWrongAddress({addresses:params}));
            setCorrectionResultList(responseCorrection);
            let paramsVerify = _.map(responseCorrection, (addressObj) => {
                return {
                    order_id: addressObj.order_id, 
                    address: addressObj.original_address, 
                    postal_code: addressObj.original_postal_code, 
                    is_invalid_address: addressObj.is_invalid_address
                };
            })
            let responseVerify = await dispatch(batchVerifyAddresses({addresses:paramsVerify}));
            setCorrectionVerifyList(responseVerify);
            setCorrectionStage('after');
        } catch(err) {
            dispatch(showAlertSnackbar({message:err.message,type:'error'}));
        } finally {
            setFullscreenLoading(false);
        }
    }

    const paramsObjectTransfer = (params, type, apiType) => {
        if(apiType === 'complete') {
            if(type === 'single' || params.operation_type === 'add' || params.operation_type === 'update') {
                return {
                    order_id: params.order_id,
                    original_address: params.address,
                    tno: params.tno,
                    original_postal_code: params.postal_code || params.zipcode,
                    is_invalid_address: false,
                    format_address: params.new_address,
                    postal_code_short: params.new_postal_code,
                    lat: params.lat,
                    lng: params.lng,
                    city: params.locality,
                    unit_number: params.unit_no,
                    street_number: params.street_number,
                    route_short: params.route,
                    neighborhood_short: null,
                    locality_short: params.locality,
                    administrative_level_1_short: params.area_level_1,
                    country_short: params.country,
                    is_apt: params.is_apt,
                    buzz_code: params.buzz_code,
                    addr_type: params.addr_type
                }
            } else {
                return {
                    ...params,
                    buzz_code: params.buzz_code,
                    addr_type: params.addr_type
                };
            }
        } else {
            return {
                order_id: params.order_id,
                address: params.address,
                postal_code: params.postal_code || params.zipcode,
                tno: params.tno
            }
        }
    }

    const paramsSingleMultiTransfer = (paramsCorrection, type, apiType) => {
        let params = [];
        if(type === 'single') {
            params.push(paramsObjectTransfer(paramsCorrection, type, apiType));
        } else {
            _.map(paramsCorrection, (content, key) => {
                params.push(paramsObjectTransfer(content, type, apiType));
            })
        }
        return params;
    }

    const handleCompleteCorrection = async(paramsCorrection, type) => {
        try {
            setFullscreenLoading(true);
            let paramsAddresses = paramsSingleMultiTransfer(paramsCorrection, type, 'complete');
            if(type === 'multi') {
                paramsAddresses = paramsAddresses.filter(addressItem => 
                    completeSelected.includes(addressItem.order_id)
                )
            }
            let params = {
                addresses: paramsAddresses,
                batch_list: batchList,
                warehouse: userPref.userCity,
                driver_id: getBranchById(userPref.userCity, branchList).wrong_address_collector,
                update_order_only: isOneTime
            }
            
            await dispatch(batchCorrectServiceWrongAddress(params));
            dispatch(showAlertSnackbar({message:t('update_success'),type:'success'}))
            if(type !== 'single') {
                props.onClose();
            }
        } catch(err) {
            dispatch(showAlertSnackbar({message:err.message,type:'error'}));
        } finally {
            setFullscreenLoading(false);
        }
    }

    const handleUpdateCloseSingle = async(params, type) => {
        try {
            if(type === 'add') {
                params.operation_type = 'add';
                params.order_id = params.id;
                params.original_address = params.address;
                params.original_postal_code = params.postal_code;
                params.corrected_addr = params.format_address || params.new_address;
                const correctionResultListNew = correctionResultList.map((item) => {
                    if (item.order_id === params.id) {
                      return params;
                    } else {
                      return item;
                    }
                });
                setCorrectionResultList(correctionResultListNew);
                setCorrectionModalOpen(false);
            } else {
                setLoading(true);
                params.operation_type = 'update';
                params.order_id = params.id;
                await handleCompleteCorrection(params, 'single', 'complete');
                setCorrectionResultList(
                    correctionResultList.filter(item =>
                        item.order_id !== params.id
                    )
                );
                setCorrectionModalOpen(false);
            }
        } catch(err) {
            dispatch(showAlertSnackbar({message:err.message,type:'error'}))
        } finally {
            setLoading(false);
        }
    }

    const handleBatchDetailOpen = (params) => {
        setCorrectDetail(params.row);
        setCorrectionModalOpen(true);
    }



    useEffect(() => {
        setCorrectionStage('before');
        setCorrectionSelected([]);
        setCompleteSelected([]);
        setAddressList({});
        setBatchList('');
        if(!branchList?.length > 0) {
            dispatch(getBranchList());
        }
        setIsOneTime(0);
    }, [props.open])

    useEffect(() => {
        setAddressList(correctionList);
    }, [correctionList])


    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                disableBackdropClick={true}
                maxWidth='lg'
                fullWidth
            >
                <DialogTitle>
                    {correctionStage === 'before' ? t('batch_correction') : t('correction_results')}
                    <Tooltip title={t('common:cancel')} aria-label="cancel" style={{float: "right"}}>
                        <CloseIcon onClick={props.onClose}></CloseIcon>
                    </Tooltip> 
                </DialogTitle>
                <DialogContent>
                    {
                        correctionStage === 'before' ?
                        <Grid container spacing={4} alignItems="center" justify="center">
                            <Grid item xs={6}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label={t('batch_list')}
                                    value={batchList}
                                    onChange={(e)=>{setBatchList(e.target.value)}}
                                    id="wrongaddressmanagement-batchcorrection-batchlist-textfield"
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    select
                                    variant="outlined"
                                    fullWidth
                                    label={t('delivery_type')}
                                    value={deliveryType}
                                    onChange={(e)=>setDeliveryType(e.target.value)}
                                    id="wrongaddressmanagement-batchcorrection-deliverytype-textfield-select"
                                >
                                    <MenuItem value={'ALL'}>{t('common:all')}</MenuItem>
                                    {
                                        _.map(deliveryTypeList, (content, key) => {
                                            return (
                                                <MenuItem value={key}>{content}</MenuItem>
                                            )
                                        })
                                    }
                                </TextField>
                            </Grid>
                            <Grid item xs={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSearch}
                                    id="wrongaddressmanagement-batchcorrection-search-button"
                                >
                                    {t('common:search')}
                                </Button>
                            </Grid>
                            <Grid item xs={3}>
                                <div>
                                    {t("wrong_addr_service_no")}{getBranchById(userPref.userCity, branchList).wrong_address_collector}
                                </div>
                            </Grid>
                            <Grid item xs={12} style={{marginTop:20}}>
                                <DataGrid
                                    style={{height: '70vh'}}
                                    loading={loading}
                                    alignItems="center"
                                    rows={createRows() || []}
                                    columns={columnsNeedCorrection}
                                    disableColumnFilter 
                                    disableColumnMenu
                                    pageSize={20}
                                    rowsPerPageOptions={[20]}
                                    isRowSelectable={false}
                                    fullWidth
                                    onSelectionModelChange={(newSelection) => {
                                        setCorrectionSelected(newSelection);
                                    }}
                                    checkboxSelection
                                />
                            </Grid>
                        </Grid>
                        :
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                {t('correction_result_start')}
                                <span style={{color:'red',fontWeight:600}}>{t('in_red')}</span>
                                {t('correction_result_end')}
                            </Grid>
                            <Grid item xs={12}>
                                <DataGrid
                                    style={{height: '70vh'}}
                                    loading={loading}
                                    alignItems="center"
                                    rows={createRows() || []}
                                    columns={columnsCorrectionResult}
                                    disableColumnFilter 
                                    disableColumnMenu
                                    pageSize={20}
                                    rowsPerPageOptions={[20]}
                                    isRowSelectable={false}
                                    fullWidth
                                    onSelectionModelChange={(newSelection) => {
                                        setCompleteSelected(newSelection);
                                    }}
                                    checkboxSelection
                                    disableSelectionOnClick
                                />
                            </Grid>
                        </Grid>
                    }
                </DialogContent>
                <DialogActions
                    style={correctionStage !== 'before' ? {
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    } : {}}
                >
                    {
                        correctionStage !== 'before' &&
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox
                                    id='wrongaddressmanagement-batchcorrection-isonetime-checkbox'
                                    color='secondary'
                                    checked={isOneTime}
                                    onChange={(e) => {
                                        setIsOneTime(e.target.checked ? 1 : 0);
                                    }}
                            />
                            <span style={{ marginRight: 4, color: 'red' }}>{t('update_one_time_only')}</span>
                            <span>{t('keep_original_stored')}</span>
                        </div>
                    }
                    <Button
                        color='primary' 
                        variant='contained'
                        style={{margin:30}}
                        onClick={()=>correctionStage === 'before' ? handleCorrect() : handleCompleteCorrection(correctionResultList,'multi','complete')}
                        disabled={correctionStage === 'before' ? !correctionSelected?.length>0 : !completeSelected?.length > 0}
                        id="wrongaddressmanagement-batchcorrection-completecorrection-button"
                    >
                        {correctionStage === 'before' ? t('correct') : t('complete_correction')}
                    </Button>
                </DialogActions>
            </Dialog>
            <CorrectionModal
                open={correctionModalOpen}
                onClose={()=>setCorrectionModalOpen(false)}
                type={'batch'}
                data={CorrectDetail}
                handleUpdateClose={handleUpdateCloseSingle}
            />
            <FullscreenLoading open={fullscreenLoading}/>
        </>
    )
}

export default BatchCorrectionModal;